import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faUserSecret } from '@fortawesome/free-solid-svg-icons'
import Utils from '../utils/utils'
import Countdown from './Countdown';
import { useTranslation } from 'react-i18next';

import {
  View,
  Text,
} from 'react-native';


export default function GameAvailable(props) {
  const { t } = useTranslation();
  const [show, setShow] = useState(props.show);
  const [gameToJoin, setGameToJoin] = useState(props.gameToJoin);

  const handleClose = () => props.setShow(false);
  const handleShow = () => setShow(true);

  const renderOneInfo = (name, text) => {
    return (
      <View style={{ marginVertical: 4, marginLeft: 6 }}>
        {name === 'time' && <Text style={{ letterSpacing: 2, color: "rgba(255,255,255,1)" }} >{t(name)}:<Text style={{ color: "rgba(255,255,255,0.6)" }} > {text === -1 ? "10 min" : text}</Text></Text>}
        {name !== 'time' && <Text style={{ letterSpacing: 2, color: "rgba(255,255,255,1)" }} >{t(name)}:<Text style={{ color: "rgba(255,255,255,0.6)" }} > {text}</Text></Text>}
      </View>

    )
  }
  return (
    <Offcanvas show={props.show} onHide={handleClose} placement="top" className="bg-dark" >
      <Offcanvas.Header className="bg-dark">
        <Offcanvas.Title style={{ color: "#FFD145", letterSpacing: 1, opacity: 0.9 }}><FontAwesomeIcon icon={faUserSecret} /> {t('new_game_available')}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body >
        <View style={{
          marginTop: -16
        }}>
        {
          ["name"].map((info) => {
            return renderOneInfo(info, gameToJoin[info])
          }
          )
        }
        </View>
        <View style={{
          flexDirection: "row"

        }}>
        {
          ["elo", "time"].map((info) => {
            return renderOneInfo(info, gameToJoin[info])
          }
          )
        }
        </View>

        
        <View style={{ marginTop: 16, marginLeft: 6, marginBottom: 14, flexDirection: "row" }}>
          <Button variant="dark" onClick={handleClose} size="sm" >
            {t('ignore')}
          </Button>
          <Button variant="warning" onClick={props.acceptGame} className="me-5" size="sm">
            {t('join_game')}
          </Button>

          
        </View>
        <Text style={{ letterSpacing: 2, color: "rgba(255,255,255,0.6)", fontSize: 12, fontStyle: "italic" }} >{t('go_back_bot')}</Text>

      </Offcanvas.Body>


    </Offcanvas>
  );
}
